import {
  IAppService,
  IServiceEndPoints,
  IRouteInfo,
  IPartnerBundle,
  ISharedComponents,
  ISharedComponentConfig,
  ComponentFramework
} from '@fxp/fxpservices';
import { appSettings } from './environments/common/appsettingsGenerator';
import { PartnerAppRegistrationService } from '@fxp/fxpservices';

export class SampleApplication_routes implements IAppService {
  getRoutes(): IRouteInfo {
    const routeInfo: IRouteInfo = {
      applicationName: 'SupportDeliveryReact',
      sharedBundles: [],
      routes: []
    };

    return routeInfo;
  }

  getServiceEndPoints(): Array<IServiceEndPoints> {
    return appSettings().serviceEndPoints;
  }

  getBundles(): IPartnerBundle[] {
    const baseUrl = appSettings().cdnBaseUrl;
    const bundle: IPartnerBundle = {
      name: 'DM-React-Bundle',
      files: [`${baseUrl}/vendor.bundle.js`, `${baseUrl}/styles.bundle.js`, `${baseUrl}/main.bundle.js`],
      sequentialLoading: true
    };

    return [bundle];
  }

  getSharedComponentsInfo(): ISharedComponents {
    const deliverySettingsSharedComponent: ISharedComponentConfig = {
generatedBundle: '02c7b1c92e07-DeliverySettings-Bundle',
      componentName: 'supportdeliveryreact.deliverysettings', // Unique name of component in format <appname>.<componentname> in lower case.
      exposeAsExternalComponents: false,
      componentFramework: ComponentFramework.React
    };

    const resourceDashboardTileSharedComponent: ISharedComponentConfig = {
generatedBundle: '02c7b1c92e07-ResourceDashboardTile-Bundle',
      componentName: 'supportdeliveryreact.resourcedashboardtile', // Unique name of component in format <appname>.<componentname> in lower case.
      exposeAsExternalComponents: false,
      componentFramework: ComponentFramework.React
    };

    const nonSupportDetailsSharedComponent: ISharedComponentConfig = {
generatedBundle: '02c7b1c92e07-NonSupportDeliveryDetails-Bundle',
      componentName: 'supportdeliveryreact.nonsupportdetails',
      exposeAsExternalComponents: false,
      componentFramework: ComponentFramework.React
    };

    const deliveryGridSharedComponent: ISharedComponentConfig = {
generatedBundle: '02c7b1c92e07-DeliveryGridContainer-Bundle',
      componentName: 'supportdeliveryreact.deliverygrid',
      exposeAsExternalComponents: false,
      componentFramework: ComponentFramework.React
    };

    const recommendationListComponentV2: ISharedComponentConfig = {
generatedBundle: '02c7b1c92e07-RecommendationListComponentV2-Bundle',
      componentName: 'supportdeliveryreact.recommendationlistv2',
      exposeAsExternalComponents: false,
      componentFramework: ComponentFramework.React
    };

    const recommendationListComponentV3: ISharedComponentConfig = {
generatedBundle: '02c7b1c92e07-RecommendationListComponentV3-Bundle',
      componentName: 'supportdeliveryreact.recommendationlistv3',
      exposeAsExternalComponents: false,
      componentFramework: ComponentFramework.React
    };

    const deliverySummaryComponent: ISharedComponentConfig = {
generatedBundle: '02c7b1c92e07-DeliverySummaryComponent-Bundle',
      componentName: 'supportdeliveryreact.deliverysummary',
      exposeAsExternalComponents: false,
      componentFramework: ComponentFramework.React
    };

    const scopingPlanComponent: ISharedComponentConfig = {
generatedBundle: '02c7b1c92e07-ScopingPlan-Bundle',
      componentName: 'supportdeliveryreact.scopingplan',
      exposeAsExternalComponents: false,
      componentFramework: ComponentFramework.React
    };

    const securityPlanTabComponent: ISharedComponentConfig = {
generatedBundle: '02c7b1c92e07-SecurityPlanTab-Bundle',
      componentName: 'supportdeliveryreact.securityplantab',
      exposeAsExternalComponents: false,
      componentFramework: ComponentFramework.React
    };

    const deliverySubmissionContainerComponent: ISharedComponentConfig = {
generatedBundle: '02c7b1c92e07-DeliverySubmissionContainer-Bundle',
      componentName: 'supportdeliveryreact.deliverysubmissioncontainer',
      exposeAsExternalComponents: false,
      componentFramework: ComponentFramework.React
    };

    const approvalComponent: ISharedComponentConfig = {
generatedBundle: '02c7b1c92e07-ApprovalComponent-Bundle',
      componentName: 'supportdeliveryreact.approvalcomponent',
      exposeAsExternalComponents: false,
      componentFramework: ComponentFramework.React
    };

    const draftApprovalStatusBannerComponent: ISharedComponentConfig = {
generatedBundle: '02c7b1c92e07-DraftApprovalStatusBannerSharedComponent-Bundle',
      componentName: 'supportdeliveryreact.draftapprovalstatusbanner',
      exposeAsExternalComponents: false,
      componentFramework: ComponentFramework.React
    };

    const approvalPanelComponent: ISharedComponentConfig = {
generatedBundle: '02c7b1c92e07-ApprovalPanel-Bundle',
      componentName: 'supportdeliveryreact.approvalpanel',
      exposeAsExternalComponents: false,
      componentFramework: ComponentFramework.React
    };

    const deliverySubmissionDrawerComponent: ISharedComponentConfig = {
generatedBundle: '02c7b1c92e07-DeliverySubmissionDrawer-Bundle',
      componentName: 'supportdeliveryreact.deliverysubmissiondrawer',
      exposeAsExternalComponents: false,
      componentFramework: ComponentFramework.React
    };

    const deliverySubmissionPageComponent: ISharedComponentConfig = {
generatedBundle: '02c7b1c92e07-DeliverySubmissionPage-Bundle',
      componentName: 'supportdeliveryreact.deliverysubmissionpage',
      exposeAsExternalComponents: false,
      componentFramework: ComponentFramework.React
    };

    const tubContentComponent: ISharedComponentConfig = {
generatedBundle: '02c7b1c92e07-TubContent-Bundle',
      componentName: 'supportdeliveryreact.tubcontent',
      exposeAsExternalComponents: false,
      componentFramework: ComponentFramework.React
    };

    const sharedComponentsInProject: ISharedComponents = {
      appName: 'SupportDeliveryReact', // Name of the application. Use the same name what you have used in main.ts file with registerPartnerApp method.
      components: [
        deliverySettingsSharedComponent,
        resourceDashboardTileSharedComponent,
        nonSupportDetailsSharedComponent,
        deliveryGridSharedComponent,
        deliverySummaryComponent,
        recommendationListComponentV2,
        recommendationListComponentV3,
        scopingPlanComponent,
        securityPlanTabComponent,
        deliverySubmissionContainerComponent,
        approvalComponent,
        draftApprovalStatusBannerComponent,
        approvalPanelComponent,
        deliverySubmissionDrawerComponent,
        deliverySubmissionPageComponent,
        tubContentComponent
      ],
      // List of ISharedComponentConfig. Add all the ISharedComponentConfig objects here.
      disableSharing: false, // Turing it off will disable the sharing and your partners will not be able to consume the components.
      sharedBundles: []
    };
    return sharedComponentsInProject;
  }
  public getGeneratedBundles() {
    var baseUrl = '';
    var currentScriptUrl = document.currentScript['src'];
    if (currentScriptUrl.indexOf('exclude.inline.bundle') > 0) {
      currentScriptUrl = Error().stack.match(/(https?:\/\/[^ ]*)/g);
      baseUrl = currentScriptUrl
        .filter((item) => item.indexOf('localhost:5000') === -1)[0]
        .toLowerCase();
      baseUrl = baseUrl.substring(0, baseUrl.lastIndexOf('/'));
    } else {
      baseUrl = currentScriptUrl.substring(0, currentScriptUrl.lastIndexOf('/'));
    }
    if (baseUrl.endsWith("/")){
        baseUrl = baseUrl.substring(0, baseUrl.lastIndexOf('/'));
    }
    // Support Delivery specific: If the URL has build parameter, then load the bundles from the build folder
    var sdBuildId = new URLSearchParams(window.location.hash.split("?").pop()).get("build");
    if (sdBuildId) {
        baseUrl = baseUrl.replace("/react", "/build") + "/" + sdBuildId + "/react";
    }
    return [
            {
                name: '02c7b1c92e07-DeliverySettings-Bundle',
                files: [
                    baseUrl + '/styles.bundle.js',
                    baseUrl + '/shared.vendor.bundle.js',
                    baseUrl + '/DeliverySettings.vendor.bundle.js',
                    baseUrl + '/DeliverySettings.bundle.js'
                ],
                sequentialLoading: true
            },
    {
                name: '02c7b1c92e07-ResourceDashboardTile-Bundle',
                files: [
                    baseUrl + '/styles.bundle.js',
                    baseUrl + '/shared.vendor.bundle.js',
                    baseUrl + '/ResourceDashboardTile.vendor.bundle.js',
                    baseUrl + '/ResourceDashboardTile.bundle.js'
                ],
                sequentialLoading: true
            },
    {
                name: '02c7b1c92e07-NonSupportDeliveryDetails-Bundle',
                files: [
                    baseUrl + '/styles.bundle.js',
                    baseUrl + '/shared.vendor.bundle.js',
                    baseUrl + '/NonSupportDeliveryDetails.vendor.bundle.js',
                    baseUrl + '/NonSupportDeliveryDetails.bundle.js'
                ],
                sequentialLoading: true
            },
    {
                name: '02c7b1c92e07-DeliveryGridContainer-Bundle',
                files: [
                    baseUrl + '/styles.bundle.js',
                    baseUrl + '/shared.vendor.bundle.js',
                    baseUrl + '/DeliveryGridContainer.vendor.bundle.js',
                    baseUrl + '/DeliveryGridContainer.bundle.js'
                ],
                sequentialLoading: true
            },
    {
                name: '02c7b1c92e07-RecommendationListComponentV2-Bundle',
                files: [
                    baseUrl + '/styles.bundle.js',
                    baseUrl + '/shared.vendor.bundle.js',
                    baseUrl + '/RecommendationListComponentV2.vendor.bundle.js',
                    baseUrl + '/RecommendationListComponentV2.bundle.js'
                ],
                sequentialLoading: true
            },
    {
                name: '02c7b1c92e07-RecommendationListComponentV3-Bundle',
                files: [
                    baseUrl + '/styles.bundle.js',
                    baseUrl + '/shared.vendor.bundle.js',
                    baseUrl + '/RecommendationListComponentV3.vendor.bundle.js',
                    baseUrl + '/RecommendationListComponentV3.bundle.js'
                ],
                sequentialLoading: true
            },
    {
                name: '02c7b1c92e07-DeliverySummaryComponent-Bundle',
                files: [
                    baseUrl + '/styles.bundle.js',
                    baseUrl + '/shared.vendor.bundle.js',
                    baseUrl + '/DeliverySummaryComponent.vendor.bundle.js',
                    baseUrl + '/DeliverySummaryComponent.bundle.js'
                ],
                sequentialLoading: true
            },
    {
                name: '02c7b1c92e07-ScopingPlan-Bundle',
                files: [
                    baseUrl + '/styles.bundle.js',
                    baseUrl + '/shared.vendor.bundle.js',
                    baseUrl + '/ScopingPlan.vendor.bundle.js',
                    baseUrl + '/ScopingPlan.bundle.js'
                ],
                sequentialLoading: true
            },
    {
                name: '02c7b1c92e07-SecurityPlanTab-Bundle',
                files: [
                    baseUrl + '/styles.bundle.js',
                    baseUrl + '/shared.vendor.bundle.js',
                    baseUrl + '/SecurityPlanTab.vendor.bundle.js',
                    baseUrl + '/SecurityPlanTab.bundle.js'
                ],
                sequentialLoading: true
            },
    {
                name: '02c7b1c92e07-DeliverySubmissionContainer-Bundle',
                files: [
                    baseUrl + '/styles.bundle.js',
                    baseUrl + '/shared.vendor.bundle.js',
                    baseUrl + '/DeliverySubmissionContainer.vendor.bundle.js',
                    baseUrl + '/DeliverySubmissionContainer.bundle.js'
                ],
                sequentialLoading: true
            },
    {
                name: '02c7b1c92e07-ApprovalComponent-Bundle',
                files: [
                    baseUrl + '/styles.bundle.js',
                    baseUrl + '/shared.vendor.bundle.js',
                    baseUrl + '/ApprovalComponent.vendor.bundle.js',
                    baseUrl + '/ApprovalComponent.bundle.js'
                ],
                sequentialLoading: true
            },
    {
                name: '02c7b1c92e07-DraftApprovalStatusBannerSharedComponent-Bundle',
                files: [
                    baseUrl + '/styles.bundle.js',
                    baseUrl + '/shared.vendor.bundle.js',
                    baseUrl + '/DraftApprovalStatusBannerSharedComponent.vendor.bundle.js',
                    baseUrl + '/DraftApprovalStatusBannerSharedComponent.bundle.js'
                ],
                sequentialLoading: true
            },
    {
                name: '02c7b1c92e07-ApprovalPanel-Bundle',
                files: [
                    baseUrl + '/styles.bundle.js',
                    baseUrl + '/shared.vendor.bundle.js',
                    baseUrl + '/ApprovalPanel.vendor.bundle.js',
                    baseUrl + '/ApprovalPanel.bundle.js'
                ],
                sequentialLoading: true
            },
    {
                name: '02c7b1c92e07-DeliverySubmissionDrawer-Bundle',
                files: [
                    baseUrl + '/styles.bundle.js',
                    baseUrl + '/shared.vendor.bundle.js',
                    baseUrl + '/DeliverySubmissionDrawer.vendor.bundle.js',
                    baseUrl + '/DeliverySubmissionDrawer.bundle.js'
                ],
                sequentialLoading: true
            },
    {
                name: '02c7b1c92e07-DeliverySubmissionPage-Bundle',
                files: [
                    baseUrl + '/styles.bundle.js',
                    baseUrl + '/shared.vendor.bundle.js',
                    baseUrl + '/DeliverySubmissionPage.vendor.bundle.js',
                    baseUrl + '/DeliverySubmissionPage.bundle.js'
                ],
                sequentialLoading: true
            },
    {
                name: '02c7b1c92e07-TubContent-Bundle',
                files: [
                    baseUrl + '/styles.bundle.js',
                    baseUrl + '/shared.vendor.bundle.js',
                    baseUrl + '/TubContent.vendor.bundle.js',
                    baseUrl + '/TubContent.bundle.js'
                ],
                sequentialLoading: true
            },

    ]
}
}

PartnerAppRegistrationService.registerLazyLoadedApp(SampleApplication_routes, 'SupportDeliveryReact');

// --- FxP Angular-21 host workaround: populate the host's registeredApps map ---
// The host's shared-component render path does `new registeredApps[appName]()` to read the
// app's ISharedComponentConfig list. registerLazyLoadedApp (above) does NOT populate that
// map, so without this the host throws "registeredApps[appName] is not a constructor".
// We register SampleApplication_routes (the generatedBundle-based routes class). It carries
// NO direct component references, so it does NOT import ./application and therefore does NOT
// pull a second copy of React/react-dom into routes.bundle.js. (react/react-dom are excluded
// from every partner chunk EXCEPT `routes`; importing components here would bundle a private
// React into routes.bundle.js, and its hooks would then clash with the shared React the host
// render bridge uses -> "Invalid hook call".) The actual component reference is supplied at
// render time by the lazy loader below, which loads the component's generatedBundle
// (e.g. DeliverySettings.bundle.js). That bundle shares React and calls
// updateSharedComponentDetails(...) to register the real component reference.
(function ensureFxpPartnerAppRegistered() {
  var registration: any = PartnerAppRegistrationService;
  if (typeof registration.registerPartnerApp !== 'function') {
    return;
  }
  try {
    registration.registerPartnerApp('SupportDeliveryReact', SampleApplication_routes);
  } catch (e) {
    // Already registered (e.g. main.bundle.js loaded) — safe to ignore.
  }
})();

// --- FxP Angular-21 host workaround: wire the shared-component lazy loader (auto-generated) ---
(function wireFxpSharedComponentLazyLoader() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }
  var registration: any = PartnerAppRegistrationService;
  if (registration.lazyLoader || typeof registration.setLazyLoader !== 'function') {
    return;
  }
  var loadedUrls: any = {};
  var loadedNames: any = {};
  // Capture the generatedBundle definitions now, during initial script execution, while
  // document.currentScript is still valid (getGeneratedBundles() derives its baseUrl from it).
  // The host invokes the loader later (asynchronously) when a shared component is rendered,
  // at which point document.currentScript is null and getGeneratedBundles() would throw.
  var generatedBundles: any[] = [];
  try {
    generatedBundles = new SampleApplication_routes().getGeneratedBundles() || [];
  } catch (e) {
    if (typeof console !== 'undefined' && console.warn) {
      console.warn('FxP shared-component loader: could not read generatedBundles', e);
    }
  }
  function findGeneratedBundle(name: string): any {
    for (var i = 0; i < generatedBundles.length; i++) {
      if (generatedBundles[i] && generatedBundles[i].name === name) {
        return generatedBundles[i];
      }
    }
    return null;
  }
  function loadScript(url: string): Promise<any> {
    if (loadedUrls[url]) {
      return Promise.resolve();
    }
    return new Promise<any>(function (resolve) {
      var script = document.createElement('script');
      script.src = url;
      script.onload = function () {
        loadedUrls[url] = true;
        resolve(undefined);
      };
      script.onerror = function () {
        // Mirror FxP host resiliency: a missing/unloadable bundle (e.g. a module
        // vendor bundle that is not emitted in hotreload mode, where its deps are
        // folded into shared.vendor.bundle.js) must not abort the whole
        // shared-component render. Mark handled, log, and continue.
        if (typeof console !== 'undefined' && console.warn) {
          console.warn('FxP shared-component loader: skipped unloadable bundle ' + url);
        }
        loadedUrls[url] = true;
        resolve(undefined);
      };
      document.head.appendChild(script);
    });
  }
  function loadModuleByName(name: string): Promise<any> {
    if (loadedNames[name]) {
      return Promise.resolve();
    }
    // Resolve the generatedBundle (styles/shared.vendor/<Component>.bundle.js) for this
    // component from the registered routes class. Loading <Component>.bundle.js executes
    // __build/<Component>.ts, which calls updateSharedComponentDetails(...) to register the
    // real React component reference with the host. Because these are non-`routes` chunks,
    // their React is the shared copy the host render bridge uses -> hooks work.
    var mod: any = findGeneratedBundle(name);
    if (!mod || !mod.files || !mod.files.length) {
      loadedNames[name] = true;
      return Promise.resolve();
    }
    // FxP Angular-21 host workaround: the component entry's webpack deferred module
    // depends on the host-provided '...-exclude' chunk (served as exclude.bundle.js),
    // which the local host never injects. Without it, checkDeferredModules never runs
    // the entry, so updateSharedComponentDetails never fires and the component ref stays
    // undefined. Prepend exclude.bundle.js so the entry's chunk dependency is satisfied.
    var lazyFiles: any = mod.files.slice();
    var lazyFirst: string = lazyFiles[0] || '';
    var lazySlash = lazyFirst.lastIndexOf('/');
    if (lazySlash > 0) {
      var lazyExclude = lazyFirst.substring(0, lazySlash) + '/exclude.bundle.js';
      if (lazyFiles.indexOf(lazyExclude) === -1) {
        lazyFiles.unshift(lazyExclude);
      }
    }
    var chain: any = Promise.resolve();
    lazyFiles.forEach(function (url: string) {
      chain = chain.then(function () {
        return loadScript(url);
      });
    });
    return chain.then(function () {
      loadedNames[name] = true;
    });
  }
  var loader = {
    load: function (moduleNames: any, options: any): Promise<any> {
      var names: any = Array.isArray(moduleNames) ? moduleNames : [moduleNames];
      if (options && (options.serie === true || options.series === true)) {
        var chain: any = Promise.resolve();
        names.forEach(function (name: string) {
          chain = chain.then(function () {
            return loadModuleByName(name);
          });
        });
        return chain;
      }
      return Promise.all(names.map(function (name: string) {
        return loadModuleByName(name);
      }));
    }
  };
  registration.setLazyLoader(loader);
  // Mark that the FxP host's own lazy-load mechanism is active so the proactive
  // DOM-observer fallback below stays dormant and does NOT double-load the bundles
  // (double-loading re-installs the webpack runtime and crashes the jsonp replay).
  try {
    (window as any).__fxpSdrLazyLoaderActive = true;
  } catch (e) {
    /* ignore */
  }
})();

// --- FxP Angular-21 host workaround: proactively load shared-component bundles + re-trigger ---
(function proactivelyLoadFxpSharedComponents() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }
  // Fallback only: if the FxP host's own lazy-load mechanism registered successfully
  // (setLazyLoader), it owns bundle loading + render. Running this proactive loader too
  // would double-load the bundles (re-installing the webpack runtime -> jsonp replay crash).
  if ((window as any).__fxpSdrLazyLoaderActive) {
    return;
  }
  var APP_NAME = 'SupportDeliveryReact';
  var routesApp: any;
  try {
    routesApp = new SampleApplication_routes();
  } catch (e) {
    return;
  }
  var compToBundle: any = {};
  try {
    var info: any = routesApp.getSharedComponentsInfo();
    var comps: any = (info && info.components) || [];
    for (var ci = 0; ci < comps.length; ci++) {
      var c: any = comps[ci];
      if (c && c.componentName && c.generatedBundle) {
        compToBundle[String(c.componentName).toLowerCase()] = c.generatedBundle;
      }
    }
  } catch (e) {
    /* ignore */
  }
  var bundleToFiles: any = {};
  try {
    var bundles: any = routesApp.getGeneratedBundles() || [];
    for (var bi = 0; bi < bundles.length; bi++) {
      if (bundles[bi] && bundles[bi].name) {
        bundleToFiles[bundles[bi].name] = bundles[bi].files || [];
      }
    }
  } catch (e) {
    /* ignore */
  }
  var loadedUrls: any = {};
  var loadedComps: any = {};
  function loadScript(url: string): Promise<any> {
    if (loadedUrls[url]) {
      return Promise.resolve();
    }
    return new Promise<any>(function (resolve) {
      var s = document.createElement('script');
      s.src = url;
      s.onload = function () {
        loadedUrls[url] = true;
        resolve(undefined);
      };
      s.onerror = function () {
        loadedUrls[url] = true;
        resolve(undefined);
      };
      document.head.appendChild(s);
    });
  }
  function loadComponent(compName: string): Promise<any> {
    var key = String(compName || '').toLowerCase();
    if (!key || loadedComps[key]) {
      return Promise.resolve();
    }
    loadedComps[key] = true;
    var bundleName = compToBundle[key];
    var files = bundleName ? bundleToFiles[bundleName] : null;
    if (!files || !files.length) {
      return Promise.resolve();
    }
    // FxP Angular-21 host workaround: the component entry's webpack deferred module
    // depends on the host-provided '...-exclude' chunk (served as exclude.bundle.js),
    // which the local host never injects. Without it, checkDeferredModules never runs
    // the entry, so updateSharedComponentDetails never fires and the component ref
    // stays undefined ("Element type is invalid: undefined"). Prepend exclude.bundle.js
    // so the entry's chunk dependency is satisfied (styles' runtime consumes it via replay).
    var allFiles: any = files.slice();
    var firstUrl: string = allFiles[0] || '';
    var slash = firstUrl.lastIndexOf('/');
    if (slash > 0) {
      var excludeUrl = firstUrl.substring(0, slash) + '/exclude.bundle.js';
      if (allFiles.indexOf(excludeUrl) === -1) {
        allFiles.unshift(excludeUrl);
      }
    }
    var chain: any = Promise.resolve();
    allFiles.forEach(function (u: string) {
      chain = chain.then(function () {
        return loadScript(u);
      });
    });
    return chain;
  }
  function isEmpty(el: any) {
    return ((el.textContent || '').trim()) === '';
  }
  function retrigger(el: any) {
    if (!el || el.getAttribute('data-fxp-retriggered') === '1') {
      return;
    }
    var parent = el.parentNode;
    if (!parent) {
      return;
    }
    var fresh: any = document.createElement(el.tagName.toLowerCase());
    for (var i = 0; i < el.attributes.length; i++) {
      fresh.setAttribute(el.attributes[i].name, el.attributes[i].value);
    }
    fresh.setAttribute('data-fxp-retriggered', '1');
    parent.replaceChild(fresh, el);
  }
  function handle(el: any) {
    if (!el || el.getAttribute('appname') !== APP_NAME) {
      return;
    }
    var comp = el.getAttribute('componentname');
    loadComponent(comp).then(function () {
      setTimeout(function () {
        if (isEmpty(el) && el.getAttribute('data-fxp-retriggered') !== '1') {
          retrigger(el);
        }
      }, 60);
    });
  }
  function scanExisting() {
    var nodes: any = document.querySelectorAll(
      'fxp-shared-component-control[appname="' + APP_NAME + '"]'
    );
    for (var i = 0; i < nodes.length; i++) {
      handle(nodes[i]);
    }
  }
  var observer = new MutationObserver(function (mutations: any) {
    for (var m = 0; m < mutations.length; m++) {
      var added: any = mutations[m].addedNodes;
      for (var n = 0; n < added.length; n++) {
        var node: any = added[n];
        if (!node || node.nodeType !== 1) {
          continue;
        }
        if (node.tagName && node.tagName.toLowerCase() === 'fxp-shared-component-control') {
          handle(node);
        } else if (node.querySelectorAll) {
          var inner: any = node.querySelectorAll(
            'fxp-shared-component-control[appname="' + APP_NAME + '"]'
          );
          for (var k = 0; k < inner.length; k++) {
            handle(inner[k]);
          }
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  scanExisting();
})();
